import type { TFunction } from 'i18next'
import { formatCredits, formatMoney, type CheckoutOrderDestination, type SandboxOrder } from './billingTypes'

/** Unmatched confirmations can still download the clearly labelled sample. */
export const SAMPLE_RECEIPT_URL = '/billing/sample-receipt.pdf'

export function checkoutWalletLabel(destination: CheckoutOrderDestination | null | undefined, t: TFunction<'settings'>): string {
  if (!destination) return t('settingsModal.billing.unknownDestination')
  if (destination.kind === 'personal') return t('settingsModal.billing.personalDestination')
  const name = destination.teamName ?? destination.teamId ?? t('settingsModal.billing.teamDestination')
  return destination.teamId === null ? t('settingsModal.billing.deletedTeamDestination', { name }) : name
}

export function sandboxWalletLabel(order: SandboxOrder, t: TFunction<'settings'>): string {
  return checkoutWalletLabel({ kind: order.destination?.kind ?? 'personal', teamId: order.destination?.teamId ?? null, teamName: order.destinationName ?? null }, t)
}

/** Plain text preserves localized names without treating them as HTML or PDF code. */
export function sandboxReceiptUrl(order: SandboxOrder, t: TFunction<'settings'>, locale: string): string {
  const text = [
    t('settingsModal.billing.sandboxTitle'),
    t('settingsModal.billing.sandboxBody'),
    `${t('settingsModal.billing.orderNumber')}: ${order.orderId}`,
    `${t('settingsModal.billing.destination')}: ${sandboxWalletLabel(order, t)}`,
    `${t('settingsModal.billing.product')}: ${formatCredits(order.credits, locale)} ${t('settingsModal.billing.credits')}`,
    `${t('settingsModal.billing.amountPaid')}: ${formatMoney(order.price, locale)}`,
    `${t('settingsModal.billing.colDate')}: ${new Date(order.paidAt ?? order.createdAt).toLocaleDateString(locale)}`,
  ].join('\n')
  return `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`
}
